module.exports = __webpack_public_path__ + "img/file_upload.fd6253fe.svg";